export const ASSET_CARD_ROW_MT = 6;

export const CDN_IMAGE_LOAD_TIMEOUT_MS = 5000;
